import { Box, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'

/** 24-bar activity histogram for the last day. */
export default function ActivityHeatmap({ vals }: { vals: number[] }) {
  const theme = useTheme()
  const c = theme.affexy.colors
  const max = Math.max(...vals, 1)

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      <Box sx={{ display: 'flex', gap: '3px', alignItems: 'flex-end', height: 48 }}>
        {vals.map((v, i) => (
          <Box
            key={i}
            title={`${String(i).padStart(2, '0')}:00 — ${v}`}
            sx={{
              flex: 1,
              height: 4 + (v / max) * 44,
              bgcolor: v > 0 ? `rgba(234,80,72,${0.2 + (v / max) * 0.7})` : c.gray100,
              borderRadius: '2px',
            }}
          />
        ))}
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        {[0, 6, 12, 18, 23].map((h) => (
          <Typography key={h} sx={{ fontSize: 10, color: c.ink48, fontVariantNumeric: 'tabular-nums' }}>
            {String(h).padStart(2, '0')}:00
          </Typography>
        ))}
      </Box>
    </Box>
  )
}
